// extracted by mini-css-extract-plugin
module.exports = {"ldsDualRing":"style_ldsDualRing__26ghz","lds-dual-ring":"style_lds-dual-ring__3Eypo"};